import { Redirect, useParams } from "react-router-dom";

import { findCarBySlug } from "@mywheels/common/lib/cars/utils";
import { useGraphCMS } from "@mywheels/common/lib/useGraphCMS";
import { useTranslation } from "@mywheels/common/lib/translation";

import { ToolbarSpacer } from "web/layout/Toolbar";
import { useRoutes } from "web/lib/i18n";

import { NotFoundPage } from "../NotFoundPage";
import { ManualSectionContent } from "./ManualSectionContent";
import { ManualPageHeader } from "./ManualPageHeader";
import { GetWebHandleidingCarQuery } from "./queries";
import { Car } from "@mywheels/common/lib/cars/types";

export default function CarManualSectionPageWrapper() {
  // eslint-disable-next-line
  const { carId, sectionId } = useParams<any>();
  const routes = useRoutes();

  const car = findCarBySlug(carId);

  if (!car) {
    return <NotFoundPage />;
  } else if (car.id !== carId) {
    return <Redirect to={routes.CarManual.url({ carId: car.id })} />;
  } else {
    return <CarManualSectionPage car={car} manualSectionSlug={sectionId} />;
  }
}

function CarManualSectionPage({
  car,
  manualSectionSlug,
}: {
  car: Car;
  manualSectionSlug: string;
}) {
  const { language } = useTranslation();

  const find = useGraphCMS(
    GetWebHandleidingCarQuery,
    car && {
      slug: car.id,
      locale: language,
    }
  );

  return (
    <div>
      <ToolbarSpacer />

      <ManualPageHeader car={car} graphcmsCar={find.data} />

      <ManualSectionContent car={car} manualSectionSlug={manualSectionSlug} />
    </div>
  );
}
